import { Link } from "react-router-dom";

import List from "@vapor/react-material/List";
import ListItem from "@vapor/react-material/ListItem";
import ListItemIcon from "@vapor/react-material/ListItemIcon";
import ListItemText from "@vapor/react-material/ListItemText";
import ArticleIcon from "@mui/icons-material/Article";
import { faBriefcase } from "@fortawesome/pro-regular-svg-icons";
import { VaporIcon } from "@vapor/react-icons/VaporIcon";

export const NavContent = () => (
  <List>
    <ListItem button component={Link} to={"/"}>
      <ListItemIcon>
        <ArticleIcon />
      </ListItemIcon>
      <ListItemText primary={"Dashboard"} />
    </ListItem>

  </List>
);
